import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { PageHeader } from '@/components/layout'
import { SettingsSidebar } from '@/components/configuracion/SettingsSidebar'
import { useSettingsPermissions } from '@/components/configuracion/hooks/useSettingsPermissions'

const ORG_ROUTES = ['/configuracion/general', '/configuracion/marca', '/configuracion/fiscal', '/configuracion/facturacion', '/configuracion/comunicaciones', '/configuracion/redes'] as const

export function Configuracion() {
  const { canViewOrgSettings, isLoading } = useSettingsPermissions()
  const location = useLocation()

  const isOrgRoute = ORG_ROUTES.some((r) => location.pathname.startsWith(r))

  // Wait for permissions to load before redirecting
  if (!isLoading && !canViewOrgSettings && isOrgRoute) {
    return <Navigate to="/configuracion/notificaciones" replace />
  }

  return (
    <div className="flex flex-col h-full">
      <PageHeader
        title="Configuración"
        description="Administra la configuración de tu cuenta y del sistema"
      />
      <div className="flex flex-1 overflow-hidden">
        <SettingsSidebar />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
